import { getTextMarkerPatch } from 'app/core/markers/models';
import { measureMarker, measureText } from 'app/utils/text';
export const updatePinOnSizeChange = (marker, value, sizeFactor, patch) => {
    const { format, metrics: { width: innerWidth, height: innerHeight, lines }, } = measureMarker(patch ? Object.assign(Object.assign({}, marker), patch) : marker, {
        fontSize: value,
        sizeFactor,
    });
    const { lines: [line], width, } = measureText(String(8), format);
    return Object.assign(Object.assign({}, patch), { size: value, width, height: line.ascent * 0.85, descent: lines[0].descent, innerWidth,
        innerHeight,
        format });
};
export const updateTextOnSizeChange = (marker, value, sizeFactor) => {
    const { format, metrics: { width, height, lines }, } = measureMarker(marker, { fontSize: value, sizeFactor });
    const change = {
        size: value,
        width,
        height,
        format,
        lines,
    };
    return getTextMarkerPatch(marker, change);
};
export const updateTextOnFormatChange = (marker, formatPatch) => {
    const format = Object.assign(Object.assign({}, marker.format), formatPatch);
    const { metrics: { width, height, lines }, } = measureMarker(marker, {
        fontSize: marker.size,
        explicitFormat: format,
    });
    const change = {
        width,
        height,
        format,
        lines,
    };
    return getTextMarkerPatch(marker, change);
};
export function patchMarker(marker, patch) {
    return snapPositionals(Object.assign(Object.assign({}, marker), patch));
}
export function snapPositionals(marker) {
    // const positionals = ['x', 'y', 'endX', 'endY'];
    // positionals.forEach(key => {
    //     if (key in marker && typeof marker[key] === 'number') {
    //         marker[key] = Math.round(marker[key] as number);
    //     }
    // });
    return marker;
}
